/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";

import { NewsCard, NewsCardProps } from "./NewsCard.molecule";
import { Flex } from "@panda/jsx";

export type NewsCardsProps = {
	cards?: NewsCardProps[] | null;
	maxCards?: number;
	hideCategoryPills?: boolean;
};

export function NewsCards({ cards = [], maxCards, hideCategoryPills }: NewsCardsProps): React.JSX.Element | null {
	if (!cards || !cards.length) return null;

	const slicedCards = cards?.slice(0, maxCards || 2);
	return (
		<div
			className={cx(
				"news-cards",
				css({
					gap: "eds.dimension.16",
					display: "flex",
					flexWrap: "wrap",
					mdDown: {
						flexDirection: "column",
						"& > div:nth-child(4)": {
							display: "none",
						},
					},
				}),
			)}
		>
			{(slicedCards || []).map((card, i) => (
				<Flex flexBasis="49%" key={`news-card-grid-item-${i}`} flexDirection="column">
					<NewsCard
						{...card}
						hideCategoryPills={hideCategoryPills}
						analytics={{
							eventCategory: "tile",
							eventLabel: card.title?.text || "",
							eventValue: {
								component: "NewsCards",
								index: i,
							},
						}}
					></NewsCard>
				</Flex>
			))}
		</div>
	);
}
